import builder from '../builder';
import CheckPaymentSign from '../../streamline-icons/light/check-payment-sign.svg';

export default builder('IconCheckPaymentSignLight', CheckPaymentSign);
